// Rezervasyon listeleri için ortak yardımcılar (AdminReservationsPage + MyReservationsPage).

export const formatDT = (iso) => {
  try {
    return new Intl.DateTimeFormat("tr-TR", { dateStyle: "short", timeStyle: "short" }).format(
      new Date(iso)
    );
  } catch {
    return iso;
  }
};

const ts = (v) => {
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
};

// pending | upcoming | past | closed
export const categorize = (r, now = Date.now()) => {
  if (r.status === "pending") return "pending";
  if (r.status === "rejected" || r.status === "cancelled") return "closed";
  return ts(r.ends_at) >= now ? "upcoming" : "past";
};

export const toDateKey = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

export const filterReservations = (list, { tab, search, vehicleId, from, to }, now = Date.now()) => {
  const q = (search || "").trim().toLocaleLowerCase("tr-TR");
  return list.filter((r) => {
    if (tab && tab !== "all") {
      const cat = categorize(r, now);
      // "Yaklaşan" sekmesi bekleyen (henüz onaylanmamış) rezervasyonları da gelecekteyse içerir
      if (tab === "upcoming") {
        if (!(cat === "upcoming" || (cat === "pending" && ts(r.ends_at) >= now))) return false;
      } else if (cat !== tab) return false;
    }
    if (vehicleId && String(r.vehicle_id) !== String(vehicleId)) return false;
    const startKey = toDateKey(r.starts_at);
    const endKey = toDateKey(r.ends_at) || startKey;
    if (from && endKey && endKey < from) return false;
    if (to && startKey && startKey > to) return false;
    if (q) {
      const hay = `${r.vehicle_name || ""} ${r.vehicle_plate || ""} ${r.owner_name || ""} ${
        r.owner_surname || ""
      } ${r.reason || ""} ${(r.participants || [])
        .map((p) => `${p.name} ${p.surname}`)
        .join(" ")}`.toLocaleLowerCase("tr-TR");
      if (!hay.includes(q)) return false;
    }
    return true;
  });
};

export const sortReservations = (list, key) => {
  const arr = [...list];
  if (key === "start_desc") return arr.sort((a, b) => ts(b.starts_at) - ts(a.starts_at));
  return arr.sort((a, b) => ts(a.starts_at) - ts(b.starts_at));
};
